import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import moment from 'moment';
import find from 'ramda/src/find';
import isEmpty from 'ramda/src/isEmpty';
import isNil from 'ramda/src/isNil';
import EditDropdown from '@components/EditDropdown';
import Rating from '~/components/@core/Rating';
import { getUnit } from '~/services/util';
import { UserRoles } from '~/services/config';
import AppActions from '~/actions/app';

const DailyScorecard = ({ scorecard, userId, date, avgscore, dayoff = false, onDailyActuals }) => {
    const dispatch = useDispatch();
    const role = useSelector((state) => state.app.app_role_id);
    const toggleModal = (payload) => dispatch(AppActions.modalRequest(payload));

    const handleDropdown = (e) => {
        switch (e) {
            case 'assign': {
                if (role === UserRoles.USER) {
                    toast.error('Only Admin and Managers can assign scorecards.', {
                        position: toast.POSITION.TOP_RIGHT,
                        pauseOnFocusLoss: false,
                        hideProgressBar: true,
                    });
                    return;
                }
                const after = {
                    type: 'GETDAILYFEED_REQUEST',
                    userId,
                };
                const payload = {
                    type: 'Assign ScoreCard',
                    data: { before: { assignees: [userId], modules: [], disabled: ['monthly', 'quarterly', 'yearly'], after } },
                };
                toggleModal(payload);
            }
        }
    };

    const renderActual = (quota) => {
        const { calculation } = quota.data;
        const target = quota?.data?.star_values ? quota.data.star_values[5] : quota?.data?.quota_target || 0;
        const actual = isEmpty(calculation) || isNil(calculation?.days[moment(date).format('YYYY-MM-DD')]) ? null : quota.data.calculation.days[moment(date).format('YYYY-MM-DD')].value;
        const _actual = find((e) => quota.id == e.quota_id && e.actual_at === moment(date).format('YYYY-MM-DD'))(quota.actuals);
        const unit = quota?.data?.quota_template?.data?.target_types;

        return (
            <div className="d-flex ai-center">
                {dayoff ? (
                    <p className="dsl-b16 m-0">Na</p>
                ) : !isNil(actual) ? (
                    <p className="dsl-b16 m-0">{getUnit(actual, unit)}</p>
                ) : _actual ? (
                    <p className="dsl-b16 m-0">Na</p>
                ) : (
                    <div className="grey_input" />
                )}
                <p className="dsl-b16 ms-1 mb-0">/ {getUnit(target, unit)}</p>
            </div>
        );
    };

    const renderScore = (quota) => {
        const { calculation } = quota.data;
        const _actual = find((e) => quota.id == e.quota_id && e.actual_at === moment(date).format('YYYY-MM-DD'))(quota.actuals);
        const score = isEmpty(calculation) || isNil(calculation?.days[moment(date).format('YYYY-MM-DD')]) ? null : calculation.days[moment(date).format('YYYY-MM-DD')]?.star_rating;
        return dayoff ? <p className="dsl-b16 m-0">Na</p> : !isNil(score) ? <Rating className="ml-1" score={score} /> : <p className="dsl-b16 m-0">{_actual ? 'Na' : 'Incomplete'}</p>;
    };

    return (
        <div className="card h-100 d-flex flex-column pb-0">
            <div className="dsl-b18 bold mb-2">Daily Scorecard</div>
            {scorecard?.status !== 3 && scorecard?.quotas?.length > 0 ? (
                <>
                    <div className="d-flex mt-4">
                        <div className="d-flex-5">
                            <span className="dsl-m12 text-400">Goal</span>
                        </div>
                        <div className="d-flex-3 px-2">
                            <p className="dsl-m12 text-400 m-0">Actual/Target</p>
                        </div>
                        <div className="d-flex-3">
                            <p className="dsl-m12 text-400 m-0">Score</p>
                        </div>
                    </div>

                    {scorecard.quotas.map((quota, index) => (
                        <div key={`qt-${index}`} className="d-flex scorecard-item cursor-pointer" onClick={onDailyActuals}>
                            <div className="d-flex-5">
                                <span className="dsl-b16">{quota.name}</span>
                            </div>
                            <div className="d-flex-3">{renderActual(quota)}</div>
                            <div className="d-flex-3">{renderScore(quota)}</div>
                        </div>
                    ))}

                    <div className="d-flex jc-between ai-center scorecard-item">
                        <p className="text-right mb-0">Daily Score</p>
                        {avgscore === 'N/A' ? <p className="dsl-b16 mb-0">Na Score</p> : <Rating score={avgscore} size="medium" />}
                    </div>
                </>
            ) : (
                <div className="no-scorecard border-top border-bottom mt-4">
                    <div className="d-flex ai-center jc-between w-100 py-2 my-1">
                        <p className="dsl-b16 text-start m-0">No daily scorecard assigned.</p>
                        <EditDropdown options={['Assign']} onChange={handleDropdown} />
                    </div>
                </div>
            )}
        </div>
    );
};

export default DailyScorecard;
